type TodoEnv = Record<string, string | undefined>;

/**
 * Explicit property read (not a bare `import.meta.env`) so Vite inlines it
 * and the Jest transform can map it.
 */
function currentEnv(): TodoEnv {
  return {
    VITE_FEATURE_TODO: import.meta.env.VITE_FEATURE_TODO,
  };
}

/** #96: the Todo module is on only where the flag is set (local dev, e2e). */
export function isTodoEnabled(env: TodoEnv = currentEnv()): boolean {
  return env.VITE_FEATURE_TODO === 'true';
}
